var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',[_c('caixa',{attrs:{"caixaInicial":_vm.caixaDaRota}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }